import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { Title as CoreTitle } from "@vds-core/typography";
import PropTypes from "prop-types";
var propTypes = {
  size: PropTypes.oneOf(["XSmall", "small", "medium", "large", "XLarge", "2XLarge"])
};
var defaultProps = {
  size: "small",
  viewport: "desktop"
};

var Title = function Title(props) {
  var _calculateLineHeight = function _calculateLineHeight() {
    var isMobile = props.viewport === "mobile";

    switch (props.size) {
      case "2XLarge":
        return isMobile ? "36px" : "64px";

      case "XLarge":
        return isMobile ? "32px" : "48px";

      case "large":
        return isMobile ? "24px" : "32px";

      case "medium":
        return isMobile ? "20px" : "24px";

      case "XSmall":
        return "16px";

      case "small":
        return isMobile ? "16px" : "20px";

      default:
        return null;
    }
  };

  var _calculateFontSize = function _calculateFontSize() {
    var isMobile = props.viewport === "mobile";

    switch (props.size) {
      case "2XLarge":
        return isMobile ? "36px" : "64px";

      case "XSmall":
        return "14px";

      default:
        return null;
    }
  };

  var _calculateLetterSpacing = function _calculateLetterSpacing() {
    if (props.viewport === "desktop" && props.size === "2XLarge") return "0px";
    return null;
  };

  return /*#__PURE__*/React.createElement(CoreTitle, _extends({}, props, {
    bold: true,
    fontSize: _calculateFontSize(),
    lineHeight: _calculateLineHeight(),
    letterSpacing: _calculateLetterSpacing()
  }));
};

Title.defaultProps = defaultProps;
Title.propTypes = propTypes;
export default Title;